// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-XkA","left":"styles_left__q2M25"};